export default __webpack_public_path__ + "static/2-99f3ea9a80c55be7295092b003a81de3.jpg";